import React from 'react';

import styles from './date_range_select.module.css';

// Shared by Program Insights and Reportable Events so the date control and its labels match.
// 6 mo is 182 days and 3 mo is 90 days, measured server-side from the current date.
export const DATE_RANGES = [
  { value: 'all', label: 'All time' },
  { value: '6m', label: '6 mo' },
  { value: '3m', label: '3 mo' },
];

export default function DateRangeSelect({ value, onChange, labelId }) {
  const current = DATE_RANGES.find((range) => range.value === value);

  return (
    <label className={styles.date_range}>
      <span className={styles.label} id={labelId}>
        Date
      </span>
      <span className={styles.date_select}>
        <span className={styles.date_value}>{current?.label}</span>
        <svg aria-hidden='true' className={styles.caret} viewBox='0 0 12 12'>
          <path d='M2.5 4.5L6 8L9.5 4.5' fill='none' stroke='currentColor' strokeLinecap='round' strokeWidth='1.5' />
        </svg>
        <select
          aria-labelledby={labelId}
          className={styles.date_input}
          onChange={(event) => onChange(event.target.value)}
          value={value}
        >
          {DATE_RANGES.map((range) => (
            <option key={range.value} value={range.value}>
              {range.label}
            </option>
          ))}
        </select>
      </span>
    </label>
  );
}
